import { apiFetch } from './client';
import { tokenStore } from './tokens';
import { config } from '@/lib/config';
import type { AuthTokens } from '@/types/api';

export type OAuthProvider = 'google' | 'github';

function beginUrl(provider: OAuthProvider, returnTo?: string): string {
  const url = new URL(`${config.apiUrl}/oauth/${provider}`);
  if (returnTo) url.searchParams.set('returnTo', returnTo);
  return url.toString();
}

export const oauthApi = {
  /** Navigate the browser to the provider's consent screen. */
  begin(provider: OAuthProvider, returnTo?: string): void {
    window.location.assign(beginUrl(provider, returnTo));
  },

  /** Exchange the one-time code handed back to the frontend for a real session. */
  async exchange(code: string): Promise<AuthTokens> {
    const tokens = await apiFetch<AuthTokens>('/oauth/exchange', {
      method: 'POST',
      body: { code },
      skipAuth: true,
    });
    tokenStore.set({
      accessToken: tokens.accessToken,
      refreshToken: tokens.refreshToken,
      expiresAt: tokens.expiresAt,
    });
    return tokens;
  },
};
